<template>
  <div class="expire-time-wrapper">
    <strong>
      인증번호는 5분 이내로 입력해 주세요.
    </strong>
    <span
      v-if="expireTime != null"
    >
      {{ minutes | twoDigits }}:{{ seconds | twoDigits }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    expireTime: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      expireInterval: null,
      minutes: null,
      seconds: null,
      code: null,
    }
  },
  watch: {
    expireTime(v) {
      this.setExpireTime()
    },
  },
  created() {
    this.setExpireTime()
  },
  methods: {
    setExpireTime() {
      if (this.expireTime == null) {
        return
      }

      if (this.expireInterval != null) {
        clearInterval(this.expireInterval)
      }
      this.setMinutesSeconds()
      this.expireInterval = setInterval(_ => {
        this.setMinutesSeconds()
      }, 1000)
    },
    setMinutesSeconds() {
      let now = new Date().getTime()
      let expireIn = Math.floor((this.expireTime - now) / 1000)

      if (expireIn < 1) {
        clearInterval(this.expireInterval)
        this.minutes = 0
        this.seconds = 0
        this.$emit('time-over')
        return
      }

      this.minutes = Math.floor(expireIn / 60)
      this.seconds = expireIn % 60
    },
  },
  filters: {
    twoDigits(value) {
      let num = Number(value)
      return num < 10 ? '0' + num : num
    },
  },
}
</script>

<style lang="scss" scoped>
.expire-time-wrapper {
  text-align: center;
  span {
    color: #25AEE1;
    font-weight: 900;
  }
}
</style>
